import { createSlice } from '@reduxjs/toolkit';
import { abbreviate } from '../components/utils/utils';

const defaultLayout = [
    { i: "1", x: 0, y: 0, w: 4, h: 3, isResizable: true, type: "incomingcallssummary" },
    { i: "2", x: 4, y: 0, w: 4, h: 3, isResizable: true, type: "outgoingcallssummary" },
    { i: "3", x: 8, y: 0, w: 4, h: 3, isResizable: true, type: "queuecallssummary" },
    { i: "4", x: 0, y: 1, w: 6, h: 3, isResizable: true, type: "socialsummary" },
    { i: "5", x: 6, y: 1, w: 6, h: 3, isResizable: true, type: "agentsstatussummary" },
    { i: "6", x: 0, y: 2, w: 3, h: 6, isResizable: true, type: "queuedcallsdetail" },
    { i: "7", x: 3, y: 2, w: 3, h: 6, isResizable: true, type: "servicequality" },
    { i: "8", x: 6, y: 2, w: 6, h: 6, isResizable: true, type: "agentscards" }
];

const supervisorSlice = createSlice({
    name: 'supervisor',
    initialState: {
        id: localStorage.getItem("id") || -1,
        token: localStorage.getItem("token") || "",
        name: localStorage.getItem("name") || "",
        fullname: localStorage.getItem("fullname") || "",
        initials: localStorage.getItem("initials") || "",
        image: localStorage.getItem("image") || "",
        groups: JSON.parse(localStorage.getItem("groups")) || [],
        groupsCorp: JSON.parse(localStorage.getItem("groupsCorp")) || [],
        changePassword: false,
        layout: JSON.parse(localStorage.getItem(`layout_user${localStorage.getItem("id")}`)) || defaultLayout,
        widgetsSettings: JSON.parse(localStorage.getItem("widgetsSettings")) || [],
        functions: JSON.parse(localStorage.getItem(`functions_user${localStorage.getItem("id")}`)) || {
            changeGroupPriority: true,
            changeGroupStatus: true,
            changeUserGroup: true,
            changeUserPriority: true,
            chat: true,
            corporativeGroups: true,
            currentStatus: true,
            enableDisableUser: true,
            freePost: true,
            intrusion: true,
            refreshStatus: true,
            setPause: true,
            transferCall: true
        }
    },
    reducers: {
        setSupervisorData: (state, action) => {

            if (action.payload) {

                state.id = action.payload.id;
                state.token = action.payload.token;
                state.name = action.payload.name;
                state.fullname = action.payload.fullName;
                state.initials = abbreviate(state.name);
                state.image = action.payload.image;
                state.groups = action.payload.supervisedGroups;
                state.groupsCorp = action.payload.supervisedCorporateGroups;
                state.changePassword = action.payload.changePassword;
                state.functions = action.payload.functions;

                localStorage.setItem("id", state.id);
                localStorage.setItem("token", state.token);
                localStorage.setItem("name", state.name);
                localStorage.setItem("fullname", state.fullname);
                localStorage.setItem("initials", state.initials);
                if (state.image)
                    localStorage.setItem("image", state.image);
                localStorage.setItem("groups", JSON.stringify(state.groups));
                localStorage.setItem("groupsCorp", JSON.stringify(state.groupsCorp));
                localStorage.setItem(`functions_user${state.id}`, JSON.stringify(state.functions));
            }
        },
        updateLayout: (state, action) => {
            if (action.payload) {
                state.layout = action.payload;
            }

            localStorage.setItem(`layout_user${state.id}`, JSON.stringify(state.layout));
        },
        updateWidget: (state, action) => {
            if (action.payload) {
                // state.layout = action.payload;
                let elem = action.payload;
                let layout = [];

                state.layout.forEach(widget => {
                    if (widget.i === elem.i) {
                        widget.w = elem.w;
                        widget.h = elem.h;
                        widget.x = elem.x;
                        widget.y = elem.y;
                    }
                    layout.push(widget);
                });

                localStorage.setItem(`layout_user${state.id}`, JSON.stringify(layout));

                state.layout = layout;
            }
        },
        removeWidget: (state, action) => {
            if (action.payload) {
                state.layout = state.layout.filter(x => x.i !== action.payload);
                localStorage.setItem(`layout_user${state.id}`, JSON.stringify(state.layout));
            }
        },
        resetLayout: (state, action) => {
            state.layout = defaultLayout;
            localStorage.setItem(`layout_user${state.id}`, JSON.stringify(state.layout));
        },
        emptyLayout: (state, action) => {
            state.layout = [];
            localStorage.setItem(`layout_user${state.id}`, JSON.stringify(state.layout));
        },
        setLayout: (state, action) => {
            state.layout = action.payload || defaultLayout;
            localStorage.setItem(`layout_user${state.id}`, JSON.stringify(state.layout));
        },
        setFunctions: (state, action) => {
            state.functions = action.payload;
            localStorage.setItem(`functions_user${state.id}`, JSON.stringify(state.layout));
        }
    }
});

export default supervisorSlice.reducer
export const { setSupervisorData, updateLayout, updateWidget, removeWidget, resetLayout, emptyLayout, setLayout, setFunctions } = supervisorSlice.actions
